import { useEffect } from 'react';

import { Modal, Form, Input, Button } from 'antd';

interface PasswordChangeModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (newPassword: string) => void;
}

const PasswordChangeModal = ({ open, onClose, onSubmit }: PasswordChangeModalProps) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (!open) {
      form.resetFields();
    }
  }, [open, form]);

  const handleSubmit = () => {
    form.validateFields().then((values) => {
      onSubmit(values.newPassword);
    }).catch((info) => {
      console.log('Validate Failed:', info);
    });
  };

  return (
    <Modal
      title="비밀번호 변경"
      open={open}
      onCancel={onClose}
      centered
      width={400}
      footer={[
        <Button key="cancel" onClick={onClose}>취소</Button>,
        <Button key="submit" type="primary" danger onClick={handleSubmit}>
          비밀번호 변경
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="새 비밀번호"
          name="newPassword"
          rules={[{ required: true, message: '새 비밀번호를 입력해주세요' }]}
        >
          <Input.Password placeholder="새 비밀번호를 입력하세요" />
        </Form.Item>

        <Form.Item
          label="비밀번호 확인"
          name="confirmPassword"
          dependencies={['newPassword']}
          rules={[
            { required: true, message: '비밀번호를 다시 입력해주세요' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('newPassword') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('비밀번호가 일치하지 않습니다.'));
              },
            }),
          ]}
        >
          <Input.Password placeholder="새 비밀번호를 다시 입력하세요" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default PasswordChangeModal;